import React, { useMemo, useState } from 'react';
import { Dropdown } from 'antd';
import {
  DropdownLabel,
  GroupSelectionOption,
  RotateIcon,
  Selected
} from '@spidertracks/components';
import MultiSelectOverlay from '@spidertracks/components/build/MultiSelectOverlay';
import styled from 'styled-components';
import { CheckboxOptionType } from 'antd/lib/checkbox';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import { useDispatch, useSelector } from 'react-redux';
import { getUserOrgData } from '../../redux/selectors/userData';
import { getOrgFilter } from '../../redux/selectors/flyingPage';
import { setOrgFilter } from '../../redux/slice/flyingPage/flyingPage';

const ClosedText = styled.span`
  text-align: left;
  overflow: hidden;
`;

const ALL_LABEL = 'All Orgs';

const FlightOrgFilter: React.FC = () => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const selectedItems = useSelector(getOrgFilter) as CheckboxValueType[];
  const [closedLabel, setClosedLabel] = useState(ALL_LABEL);
  const userOrgs = useSelector(getUserOrgData);

  if (userOrgs === undefined) {
    return <></>;
  }

  const confirm = () => setVisible(false);
  const reset = () => {
    dispatch(setOrgFilter(['*']));
    setClosedLabel(ALL_LABEL);
    setVisible(false);
  };

  const options: CheckboxOptionType[] = userOrgs.map(org => ({
    label: org.org.orgName,
    value: org.org.id
  }));

  const groups: GroupSelectionOption[] = useMemo(
    () => [
      {
        label: ALL_LABEL,
        id: '*',
        onSelectFilter: () => true,
        isSelectAll: true
      }
    ],
    [options]
  );

  const onSelect = (selectedItems: Selected[]): void => {
    console.log(selectedItems);

    if (selectedItems[0]?.group === '*' || selectedItems.length === options.length) {
      dispatch(setOrgFilter(['*']));
      setClosedLabel(ALL_LABEL);
    } else {
      dispatch(setOrgFilter(selectedItems.map(e => e.value as string)));
      setClosedLabel(
        selectedItems.length === 1
          ? options.find(option => option.value === selectedItems[0].value)?.label?.toString() ??
              '1 Org'
          : `${selectedItems.length} Orgs`
      );
    }
  };

  return (
    <div className={`flight-detail-filter-common ${selectedItems[0] === '*' ? '' : 'active'}`}>
      <Dropdown
        disabled={false}
        onVisibleChange={() => setVisible(!visible)}
        overlay={
          <MultiSelectOverlay
            displayName="Organisation"
            onConfirm={confirm}
            onReset={reset}
            onSelect={onSelect}
            options={options}
            selected={selectedItems}
            showSearch
            visible
            shifted
            style={{
              marginTop: '-0.15rem'
            }}
            groups={groups}
            showFooter={true}
          />
        }
        trigger={['click']}
        visible={visible}
      >
        <DropdownLabel onClick={e => e.preventDefault()} disabled={false}>
          <ClosedText>{closedLabel}</ClosedText>
          <RotateIcon type="down" rotate={+visible * 180} />
        </DropdownLabel>
      </Dropdown>
    </div>
  );
};

export default FlightOrgFilter;
